

import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'



/* Hooks */
import useFlashMessage from '../../../../hooks/useFlashMessage'

/* form */
import FormBudgetItem from './Form/FormBudgetItem'
import RandomString from '../../../../shared/functions/RandomString'

function NewBudgetItem({ btCancelAction, handleOnSuccess, handleOnAddItem, clientId, permission }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()




    function registerBudgetItem(budgetItem) {
        
        let data = budgetItem
        let id = RandomString(16)
        data = { ...data, id: id }

        handleOnAddItem(data)

    }

    return (
        <FormBudgetItem title="Adicionar Item" clientId={clientId} permission={permission} handleSubmit={registerBudgetItem} btCancelAction={btCancelAction} btnText="Concluir" btnVariant="finish" handleOnSuccess={handleOnSuccess} />
    )
}

export default NewBudgetItem